import React from 'react';
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { classNames } from '../../utils/classNames';
import { useTheme } from '../../contexts/ThemeContext';

type ThemeToggleProps = {
  className?: string;
  size?: 'sm' | 'md';
};

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className, size = 'md' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={classNames(
        'group inline-flex items-center gap-2 rounded-full border border-[var(--app-border)] bg-[var(--app-surface)] text-[var(--app-text)] transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--app-ring-offset)] hover:border-primary-200 hover:bg-[var(--app-surface-subtle)] shadow-soft sm:shadow-sm',
        size === 'sm' ? 'h-9 px-3 text-xs font-semibold' : 'h-10 px-3.5 text-sm font-semibold',
        className
      )}
      aria-pressed={isDark}
      aria-label={isDark ? 'Включить светлую тему' : 'Включить тёмную тему'}
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <SunIcon
          className={classNames(
            'h-4 w-4 transition-transform duration-200 ease-out',
            isDark ? 'scale-75 opacity-40' : 'scale-100 opacity-100'
          )}
        />
        <MoonIcon
          className={classNames(
            'absolute h-4 w-4 transition-transform duration-200 ease-out',
            isDark ? 'scale-100 opacity-100' : 'scale-75 opacity-0'
          )}
        />
      </span>
      <span className="hidden sm:inline">{isDark ? 'Темная тема' : 'Светлая тема'}</span>
    </button>
  );
};

export default ThemeToggle;


